export const WRAPPER_CLASS_NAME = 'wrapper'
export const DESKTOP_WRAPPER_WIDTH = 1200
